"use client";

import React, { FunctionComponent, useEffect, useRef } from "react";
import { HiX } from "react-icons/hi";
import { Dismiss } from "flowbite";

import { IBanner, IBannerFields } from "@/types/generated/contentful";
import RichText from "../richtext";
import CallToAction from "../callToAction";

type Props = {
  content: IBanner;
};

const Banner: FunctionComponent<Props> = ({ content }) => {
  const { background, body, foreground, textAlignment, cta } =
    content.fields as IBannerFields;

  const dismiss = useRef<any>();

  useEffect(() => {
    const $targetEl: HTMLElement = document.getElementById(
      "banner",
    ) as HTMLElement;

    dismiss.current = new Dismiss($targetEl);
  }, []);

  let textAlign = "text-left items-start lg:items-center";
  switch (textAlignment) {
    case "center":
      textAlign = "text-center items-center lg:items-center";
      break;
    case "right":
      textAlign = "text-right items-end lg:items-center";
      break;
    default:
      textAlign = "text-left items-start lg:items-center";
      break;
  }

  return (
    <div
      id="banner"
      className="relative isolate flex items-center gap-x-6 overflow-hidden bg-gray-50 p-4 sm:before:flex-1"
      style={{
        backgroundColor: background || "transparent",
        ...(foreground && { color: foreground }),
      }}
    >
      <div className="flex items-center justify-center gap-x-4 gap-y-2">
        <RichText content={body} textSize="text-center text-xs md:text-base" />
        <div className="shrink">{cta && <CallToAction content={cta} />}</div>
      </div>
      <div className="flex flex-1 justify-end">
        <button
          type="button"
          className="-m-3 p-3 focus-visible:outline-offset-[-4px]"
          onClick={() => dismiss.current.hide()}
        >
          <span className="sr-only">Dismiss</span>
          <svg
            className="size-5"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
            data-slot="icon"
          >
            <path d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default Banner;
